import SmsSimulatorPersonasModal from "containers/sms-simulator/sms-simulator-personas/components/persona-modal/sms-simulator-personas-modal";

import { useCreatePersona } from "hooks/api/use-sms-simulator-personas";

import {
  AddPersonaProps,
  SmsSimulatorPersonaRequest,
} from "containers/sms-simulator/sms-simulator-personas/sms-simulator-personas.types";

const SmsSimulatorAddPersona = ({ setIsAddPersonaModalOpen }: AddPersonaProps) => {
  const createPersona = useCreatePersona();

  const handleAddPersona = async (data: SmsSimulatorPersonaRequest) => {
    try {
      await createPersona.mutateAsync(data);
      setIsAddPersonaModalOpen(false);
    } catch {
      // Error toast handled in the mutation.
    }
  };

  return (
    <SmsSimulatorPersonasModal
      onCloseCallback={() => setIsAddPersonaModalOpen(false)}
      onConfirmCallback={handleAddPersona}
      title="Add a new persona"
      subheader="Please provide the persona you would like to add to the system model."
    />
  );
};

export default SmsSimulatorAddPersona;
